export const examSkin = (() => {
    const placeHolderText = 'No rashes, no ecchymosis'

    return placeHolderText
})